import { useState, useEffect, useRef } from "react";

import { 
  Button, Input, InputGroup, InputRightElement, Stack,
  RadioGroup, Radio, Image, Flex, Text,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody } from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons';

import { insertProduct } from '../../../../services/ProductAPI';
import sampleImage from '../../../../images/sample.png'

const ProductAdditionModal = (props) => {
  const [name, setName] = useState('');
  const [sortType, setSortType] = useState('1')
  const [file, setFile] = useState('');
  const [imgBase64, setImgBase64] = useState(null); // 파일 base64

  const inputRef = useRef(null);

  const [isNameValid, setIsNameValid] = useState(true)

  const openFileExplorer = () => {
    inputRef.current.click();
  }

  const fileChange = (event) => {
    setFile(event.target.files[0]);

    setImgBase64([]);
    
    for(var i=0;i<event.target.files.length;i++){
      if (event.target.files[i]) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
        // 파일 상태 업데이트
        reader.onloadend = () => {
          // 2. 읽기가 완료되면 아래코드가 실행.
          const base64 = reader.result;
          if (base64) {
          // 문자 형태로 저장
          var base64Sub = base64.toString()
          // 배열 state 업데이트
          setImgBase64(imgBase64 => [...imgBase64, base64Sub]);
          }
        }
      }
    }
  }

  const removeFile = () => {
    setFile('')
    setImgBase64(null)
  }

  const addProduct = () => {
    if(name == '' || name == null){
      setIsNameValid(false)
      return
    }

    if(file == '' || file == null){
      alert("제품 사진을 추가해주세요!")
      return
    }

    insertProduct(name, sortType, file).then(result => {
      alert("제품이 추가되었습니다!");
      props.setIsProductUpdated(true)
      props.additionModal.onClose()
    })
  }

  useEffect(() => {
    if (props.additionModal.isOpen) {
      setName('')
      setFile('')
      setSortType('1')
    }
  }, [props.additionModal.isOpen])

  return(
    <Modal
      onClose={props.additionModal.onClose}
      isOpen={props.additionModal.isOpen}
      isCentered>
      <ModalOverlay />

      <ModalContent
        maxW='500px'>
        <ModalHeader p='20px'>
          <div className='text-4xl pb-[10px]'>추가</div>
          <div className='text-2xl'>아래에 추가하려는 제품 정보를 입력하고 추가 버튼을 눌러주세요</div>
        </ModalHeader>

        <ModalBody px='20px'>
          <Stack direction='column'>
            <Stack direction='column' pb='20px'>
              <div className='text-2xl'>제품명</div>

              <Stack direction='row' spacing={2}>
                <Input
                  variant='outline'
                  fontSize='3xl'
                  py='20px'
                  w='80%'
                  value={name || ''}
                  onChange={(event) => {setName(event.target.value); setIsNameValid(true)}}
                  isInvalid={ !isNameValid }
                  errorBorderColor='crimson'
                />
              </Stack>
            </Stack>

            <Stack direction='column' pb='20px'>
              <div className='text-2xl'>제품 사진</div>
              <Stack direction='row' spacing={2}>
                <InputGroup w='80%'>
                  <Input
                    ref={inputRef}
                    value={file && file.name !== undefined ? file.name : '선택된 파일이 없습니다'}
                    fontSize='3xl'
                    color={file && file.name !== undefined ? 'black' : '#a8a8a8'}
                    py='20px'
                    isReadOnly
                    focusBorderColor='none'
                    _hover={{}}
                  />
                  <input
                    style={{display: 'none'}} ref={inputRef} type="file" accept="image/*" 
                    onChange={fileChange}/>
                  {file !== null && file !== '' && file.name !== undefined &&
                    <InputRightElement children={<CloseIcon color="gray.500" />} p='20px'
                      onClick={() => removeFile()} cursor='pointer'/>}
                </InputGroup>
                <Button
                  colorScheme='red' fontSize='2xl' py='20px' px='10px' w='20%'
                  onClick={openFileExplorer}>
                  파일 선택
                </Button>
              </Stack>
            </Stack>

            <Stack direction='column' mb='10px'>
              <div className='text-2xl'>제품 타입</div>

              <RadioGroup fontSize='3xl' size='lg' defaultValue={sortType} value={sortType}>
                <Stack direction='row' gap='20px'>
                  <Stack spacing={2} direction='row' gap='5px' cursor='pointer'>
                    <Radio value='1' size='lg' colorScheme='green' onChange={(event) => setSortType(event.target.value)}></Radio>
                    <span style={{fontSize: '18px', display: 'flex', justifyContent: 'center'}} onClick={() => setSortType('1')}>Type1</span>
                  </Stack>
                  <Stack spacing={2} direction='row' gap='5px' cursor='pointer'>
                    <Radio value='2' size='lg' colorScheme='green' onChange={(event) => setSortType(event.target.value)}></Radio>
                    <span style={{fontSize: '18px', display: 'flex', justifyContent: 'center'}}  onClick={() => setSortType('2')}>Type2</span>
                  </Stack>
                  <Stack spacing={2} direction='row' gap='5px' cursor='pointer'>
                    <Radio value='3' size='lg' colorScheme='green' onChange={(event) => setSortType(event.target.value)}></Radio>
                    <span style={{fontSize: '18px', display: 'flex', justifyContent: 'center'}} onClick={() => setSortType('3')}>Type3</span>
                  </Stack>
                </Stack>
              </RadioGroup>
            </Stack>
            
            {sortType == 1 ? (
              <>
                <div className='text-red-600 text-2xl'>(제품 추가 후 타입 변경은 불가능합니다)</div>
                <div style={{border: '1px solid #DCDCDC', padding: '10px'}}>
                  <Flex alignContent="center" ml="40px">
                    <Text fontSize="2xl" fontWeight={800} mt="-3px" width="300px">
                      &nbsp;제품명이 표시됩니다
                    </Text>
                  </Flex>
                  <Image
                    mt="10px"
                    mb="10px"
                    height="200px"
                    w='100%'
                    objectFit='cover'
                    src={sampleImage}
                    alt="미리보기"
                  />
                  <Flex alignContent="center" mt="10px">
                    <Text fontSize="2xl" fontWeight={800} mt="-3px" width="300px">
                      &nbsp;제품에 대한 상세 내용이 표시됩니다
                    </Text>
                  </Flex>
                </div>
              </>
            ) : sortType == 2 ? (
              <>
                <div className='text-red-700 text-2xl'>(제품 추가 후 타입 변경은 불가능합니다)</div>

                <div style={{border: '1px solid #DCDCDC', padding: '10px'}}>
                  <Flex alignContent="center" ml="40px">
                    <Text fontSize="2xl" fontWeight={800} mt="-3px" width="300px">
                      &nbsp;제품명이 표시됩니다
                    </Text>
                  </Flex>
                  <div className="flex justify-center relative">
                    <Image
                      mt="10px"
                      mb="10px"
                      height="200px"
                      w='100%'
                      objectFit='cover'
                      src={sampleImage}
                      alt="미리보기"
                    />

                    <div className="absolute bottom-0 left-0 w-full">
                      <div className="flex justify-center">
                        <div className="w-1/2 catalogue_button font-bold">
                        온라인카다로그
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className='text-red-600 text-2xl'>(제품 추가 후 타입 변경은 불가능합니다)</div>

                <div style={{border: '1px solid #DCDCDC', padding: '10px'}}>
                  <Text fontSize="2xl" fontWeight={800} mt="-3px" width="300px">
                    &nbsp;제품명이 표시됩니다
                  </Text>
                  <Flex alignContent="center">
                    <Image
                      mt="10px"
                      mb="10px"                 
                      w='70%'
                      height="200px"
                      objectFit='cover'
                      src={sampleImage}
                      alt="미리보기"
                    />
                    <Flex alignContent="center" ml="10px" mb="10px" mt="10px">
                      <Text fontSize="2xl" fontWeight={800} mt="-3px" background='#DCDCDC' p='10px'>
                        &nbsp;제품에 대한 상세 내용이 표시됩니다
                      </Text>
                    </Flex>
                  </Flex>
                </div>
              </>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter pb='20px' px='20px'>
          <Button
            py='20px'
            mr='10px'
            fontSize='3xl'
            onClick={props.additionModal.onClose}>
              취소
          </Button>
          <Button 
            py='20px'
            fontSize='3xl'
            onClick={() => addProduct()}>
              추가
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ProductAdditionModal